<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      router-link.btn.btn-primary.edit-configuration-button(:to="{name: 'configurationEdit'}" kz-restrict="ROLE_SECURITY_ADMIN,ROLE_ADMIN,ROLE_ORGANIZATION_ADMIN")
        i.fa.fa-edit
        span.ml5 Edit

    .row(v-if="cfg")
      .col-md-6
        .panel.panel-default
          .panel-heading
            h3.panel-title KCEngine
          .panel-body
            .container-fluid
              .row
                label.col-sm-8 Default code length
                .col-sm-4 {{cfg.KCENGINE_DEFAULT_CODE_LENGTH}}
              .row
                label.col-sm-8 Default code case
                .col-sm-4 {{cfg.KCENGINE_DEFAULT_CODE_CASE | codeCase}}
        .panel.panel-default
          .panel-heading
            h3.panel-title Misc
          .panel-body
            .container-fluid
              .row
                .col-sm-8 Custom UI
                .col-sm-4 {{cfg.CUSTOM_UI}}

      .col-md-6
        .panel.panel-default
          .panel-heading
            h3.panel-title Security
          .panel-body
            .container-fluid
              .row
                label.col-sm-8 Max failed login attempts
                .col-sm-4 {{cfg.MAX_FAILED_LOGIN_ATTEMPTS}}

        .panel.panel-default
          .panel-heading
            h3.panel-title Metadata
          .panel-body
            .container-fluid
              .row
                label.col-sm-8 Validate json
                .col-sm-4 {{cfg.METADATA_VALIDATE_JSON}}
        .panel.panel-default
          .panel-heading
            h3.panel-title User
          .panel-body
            .container-fluid
              .row
                label.col-sm-8 Default timezone
                .col-sm-4 {{cfg.USER_DEFAULT_TIMEZONE}}

</template>
<script>
import Security from '@/service/apis/Security'

export default {
  data: () => ({
    cfg: null
  }),
  created() {
    Security.getConfiguration()
      .then((resp) => {
        const cfg = {}
        for (let i = 0; i < resp.data.entry.length; i += 1) {
          cfg[resp.data.entry[i].key] = resp.data.entry[i].value
        }
        this.cfg = cfg
      })
      .catch((e) => {
        this.$emit('error', e)
      })
  },
  filters: {
    codeCase(value) {
      if (value === 'LOWERCASE') {
        return 'lowercase'
      }
      return value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/security/Configuration.vue